export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  image: string;
  imageWidth: number;
  imageHeight: number;
  hotScore: number;
  date: string;
  author: string;
  tags: string[];
  isExclusive: boolean;
}

export const trendingArticles: Article[] = [
  {
    id: 'article-001',
    title: '某顶流艺人深夜密会神秘女子，酒店同出入被拍全程',
    excerpt: '据知情人士透露，该艺人近期行程异常，多次被目击与同一女子出入高端酒店，经纪人回应称只是普通朋友聚会。',
    category: '明星爆料',
    categorySlug: 'star',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20night%20scene%20with%20luxury%20hotel%20entrance%20and%20paparazzi%20flash%20photography%20vibe%2C%20cinematic%20lighting%20with%20warm%20golden%20and%20deep%20red%20color%20palette%2C%20abstract%20artistic%20style%20with%20soft%20bokeh%20background%2C%20editorial%20photography%20composition%2C%20mysterious%20and%20dramatic%20atmosphere%2C%20no%20text%20or%20watermark%2C%20clean%20minimal%20subject%20focus&width=800&height=1067&seq=trending-001&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 98234,
    date: '2026-07-06',
    author: '吃瓜前线',
    tags: ['顶流艺人', '恋情曝光', '深夜密会'],
    isExclusive: true,
  },
  {
    id: 'article-002',
    title: '千万粉丝网红直播间翻车，口误爆出行业内幕引热议',
    excerpt: '该网红在带货直播中不慎说漏嘴，透露了某知名品牌产品成本价不到售价十分之一，引发粉丝集体质疑，品牌方紧急发声明。',
    category: '网红吃瓜',
    categorySlug: 'influencer',
    image: 'https://readdy.ai/api/search-image?query=Livestreaming%20studio%20setup%20with%20ring%20light%20and%20professional%20camera%20equipment%2C%20dramatic%20red%20and%20warm%20amber%20lighting%2C%20abstract%20artistic%20style%20with%20soft%20depth%20of%20field%2C%20modern%20influencer%20aesthetic%2C%20clean%20composition%20with%20minimal%20distractions%2C%20editorial%20photography%20with%20cinematic%20tones%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=trending-002&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 87521,
    date: '2026-07-06',
    author: '直播间探员',
    tags: ['网红翻车', '直播带货', '行业内幕'],
    isExclusive: false,
  },
  {
    id: 'article-003',
    title: '知名女星与前夫财产分割案最新进展，涉及金额超九位数',
    excerpt: '法院最新庭审记录曝光，双方就海外多处房产及公司股权归属争执不下，律师团队已就核心资产达成部分初步协议。',
    category: '明星爆料',
    categorySlug: 'star',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20mansion%20exterior%20with%20dramatic%20stormy%20sky%2C%20warm%20golden%20sunset%20light%20breaking%20through%20dark%20clouds%2C%20abstract%20artistic%20style%2C%20cinematic%20composition%20with%20deep%20shadows%20and%20rich%20contrast%2C%20editorial%20photography%20aesthetic%2C%20sophisticated%20and%20mysterious%20mood%2C%20clean%20minimal%20focus%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=trending-003&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 76340,
    date: '2026-07-05',
    author: '法律观察员',
    tags: ['明星离婚', '财产分割', '豪门纠纷'],
    isExclusive: true,
  },
  {
    id: 'article-004',
    title: '某选秀冠军被曝学历造假，母校紧急回应正在核实中',
    excerpt: '网友扒出该艺人学历证书编号在学信网无法查询，相关证书照片存在PS痕迹，事件持续发酵中，粉丝后援会呼吁理性等待官方通报。',
    category: '明星爆料',
    categorySlug: 'star',
    image: 'https://readdy.ai/api/search-image?query=University%20campus%20library%20interior%20with%20dramatic%20shaft%20of%20light%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20abstract%20artistic%20style%20with%20bookshelves%20in%20soft%20blur%2C%20cinematic%20lighting%20with%20strong%20contrast%2C%20editorial%20photography%20composition%2C%20mysterious%20academic%20atmosphere%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=trending-004&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 65420,
    date: '2026-07-05',
    author: '学术打假人',
    tags: ['学历造假', '选秀冠军', '人设崩塌'],
    isExclusive: false,
  },
];

export const competitionArticles: Article[] = [
  {
    id: 'comp-001',
    title: '今日大赛：谁能想到这个十八线小演员竟然是隐藏富二代',
    excerpt: '网友扒出其家族企业市值超百亿，父亲是某上市公司董事长，本人却低调跑龙套多年从未张扬。',
    category: '每日大赛',
    categorySlug: 'competition',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20watch%20and%20designer%20accessories%20on%20dark%20velvet%20background%2C%20warm%20golden%20and%20deep%20red%20color%20palette%2C%20abstract%20artistic%20style%20with%20soft%20reflections%2C%20editorial%20photography%20with%20rich%20contrast%20lighting%2C%20sophisticated%20elegant%20composition%2C%20mysterious%20luxurious%20mood%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=comp-001&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 123450,
    date: '2026-07-07',
    author: '吃瓜大赛组委会',
    tags: ['隐藏富二代', '跑龙套', '家族企业'],
    isExclusive: true,
  },
  {
    id: 'comp-002',
    title: '娱乐圈最离谱合约曝光：艺人被要求十年内不得恋爱',
    excerpt: '某经纪公司内部合同条款流出，包含大量不合理限制条款，业内前辈纷纷发声谴责这种霸王合约。',
    category: '每日大赛',
    categorySlug: 'competition',
    image: 'https://readdy.ai/api/search-image?query=Legal%20contract%20documents%20on%20dark%20desk%20with%20dramatic%20side%20lighting%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20abstract%20artistic%20style%20with%20shallow%20depth%20of%20field%2C%20cinematic%20composition%2C%20editorial%20photography%20aesthetic%2C%20serious%20and%20mysterious%20mood%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=comp-002&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 98760,
    date: '2026-07-07',
    author: '吃瓜大赛组委会',
    tags: ['霸王合约', '经纪公司', '业内爆料'],
    isExclusive: false,
  },
  {
    id: 'comp-003',
    title: '两大人气综艺节目疑似抄袭，网友逐帧对比画面惊人相似',
    excerpt: '热心观众将两档节目最新一期内容逐帧对比，发现了23处高度雷同的桥段和运镜方式，引发全网热议。',
    category: '每日大赛',
    categorySlug: 'competition',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20production%20set%20with%20professional%20cameras%20and%20dramatic%20lighting%2C%20warm%20golden%20and%20deep%20red%20color%20palette%2C%20abstract%20artistic%20style%20with%20lens%20flare%2C%20cinematic%20composition%2C%20editorial%20photography%20aesthetic%2C%20dynamic%20production%20atmosphere%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=comp-003&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 85430,
    date: '2026-07-06',
    author: '吃瓜大赛组委会',
    tags: ['综艺抄袭', '逐帧对比', '全网热议'],
    isExclusive: true,
  },
  {
    id: 'comp-004',
    title: '某知名导演新片选角内幕：带资进组已成行业公开秘密',
    excerpt: '多位业内人士证实，该导演新作主演中有三人为投资方指定人选，与导演最初构思的演员阵容相去甚远。',
    category: '每日大赛',
    categorySlug: 'competition',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20chair%20and%20clapperboard%20on%20dark%20movie%20set%2C%20warm%20amber%20spotlight%20and%20deep%20red%20accents%2C%20abstract%20artistic%20style%20with%20cinematic%20lighting%2C%20editorial%20photography%20composition%2C%20mysterious%20backstage%20atmosphere%2C%20rich%20contrast%20and%20shadows%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=comp-004&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 72340,
    date: '2026-07-06',
    author: '吃瓜大赛组委会',
    tags: ['带资进组', '选角内幕', '知名导演'],
    isExclusive: false,
  },
];

export const socialArticles: Article[] = [
  {
    id: 'social-001',
    title: '某城市整顿娱乐场所，多家知名夜店被临时查封引热议',
    excerpt: '当地公安部门联合文化执法大队对辖区内娱乐场所展开突击检查，多家知名夜店存在违规经营问题被临时查封，涉及金额超千万。',
    category: '社会热点',
    categorySlug: 'social',
    image: 'https://readdy.ai/api/search-image?query=Urban%20nightlife%20district%20at%20night%20with%20police%20lights%20reflecting%2C%20warm%20amber%20street%20lighting%2C%20abstract%20artistic%20style%20with%20dramatic%20shadows%2C%20editorial%20photography%20composition%2C%20serious%20and%20intense%20atmosphere%2C%20clean%20minimal%20focus%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=social-001&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 89210,
    date: '2026-07-06',
    author: '社会观察员',
    tags: ['娱乐场所', '突击检查', '违规经营'],
    isExclusive: true,
  },
  {
    id: 'social-002',
    title: '娱乐圈税务风波再起，多名艺人被约谈补缴税款',
    excerpt: '税务部门近期加大了对高收入群体特别是娱乐圈从业人员的稽查力度，据悉已有十余名艺人收到约谈通知，涉及补缴税款总额或达数亿元。',
    category: '社会热点',
    categorySlug: 'social',
    image: 'https://readdy.ai/api/search-image?query=Office%20desk%20with%20tax%20documents%20and%20calculator%20under%20dramatic%20lighting%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20abstract%20artistic%20style%20with%20shallow%20depth%20of%20field%2C%20cinematic%20editorial%20photography%2C%20serious%20business%20atmosphere%2C%20clean%20minimal%20composition%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=social-002&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 75680,
    date: '2026-07-05',
    author: '财经观察',
    tags: ['税务风波', '艺人补税', '行业整顿'],
    isExclusive: false,
  },
  {
    id: 'social-003',
    title: '粉丝集资乱象调查：后援会账目不透明，百万资金去向成谜',
    excerpt: '记者深入调查发现，多个流量明星官方后援会存在账目混乱、资金去向不明等问题，粉丝集资总额高达数百万元却无法提供清晰支出明细。',
    category: '社会热点',
    categorySlug: 'social',
    image: 'https://readdy.ai/api/search-image?query=Crowd%20of%20fans%20holding%20light%20sticks%20at%20concert%20venue%2C%20warm%20golden%20lighting%20with%20dramatic%20atmosphere%2C%20abstract%20artistic%20style%2C%20editorial%20photography%20with%20soft%20focus%20background%2C%20emotional%20and%20passionate%20mood%2C%20clean%20composition%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=social-003&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 68450,
    date: '2026-07-04',
    author: '深度调查',
    tags: ['粉丝集资', '后援会', '资金去向'],
    isExclusive: true,
  },
  {
    id: 'social-004',
    title: '网红直播打赏新规出台，未成年人单次打赏上限500元',
    excerpt: '国家网信办联合多部门发布直播打赏管理新规，明确要求平台对未成年人打赏设置严格限额，并要求对单次超过一定金额的打赏进行冷静期提示。',
    category: '社会热点',
    categorySlug: 'social',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20livestream%20interface%20with%20gift%20icons%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20abstract%20artistic%20style%2C%20modern%20digital%20aesthetic%2C%20editorial%20photography%20composition%2C%20contemporary%20tech%20atmosphere%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=social-004&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 52340,
    date: '2026-07-03',
    author: '政策解读',
    tags: ['直播打赏', '新规出台', '未成年人保护'],
    isExclusive: false,
  },
];

export const videoArticles: Article[] = [
  {
    id: 'video-001',
    title: '独家视频：某流量明星后台发飙全程录像曝光，场面一度失控',
    excerpt: '一段疑似某当红流量艺人在综艺录制后台发飙的视频在网络上疯传，视频中该艺人情绪激动、摔砸物品，工作人员手足无措，引发全网讨论。',
    category: '51吃瓜视频',
    categorySlug: 'video',
    image: 'https://readdy.ai/api/search-image?query=Backstage%20corridor%20with%20dramatic%20shadows%20and%20warm%20spotlight%2C%20theatrical%20atmosphere%20with%20tension%2C%20abstract%20artistic%20style%2C%20cinematic%20composition%20with%20deep%20contrast%2C%20editorial%20photography%20mood%2C%20mysterious%20and%20intense%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=video-001&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 95430,
    date: '2026-07-06',
    author: '前线摄像',
    tags: ['独家视频', '后台发飙', '流量明星'],
    isExclusive: true,
  },
  {
    id: 'video-002',
    title: '网红直播间惊人一幕：助理不小心拍到后台真实场景',
    excerpt: '某头部带货网红直播过程中，助理不慎将镜头转向后台，意外曝光了直播间的真实运作场景，堆满货物的仓库和数十名工作人员引发网友惊叹。',
    category: '51吃瓜视频',
    categorySlug: 'video',
    image: 'https://readdy.ai/api/search-image?query=Warehouse%20filled%20with%20stacked%20boxes%20and%20products%2C%20dramatic%20warm%20amber%20lighting%2C%20abstract%20artistic%20style%20with%20cinematic%20composition%2C%20behind%20the%20scenes%20atmosphere%2C%20editorial%20photography%20aesthetic%2C%20mysterious%20and%20revealing%20mood%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=video-002&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 82340,
    date: '2026-07-05',
    author: '直播间探员',
    tags: ['直播翻车', '后台曝光', '带货幕后'],
    isExclusive: false,
  },
  {
    id: 'video-003',
    title: '实拍直击：某综艺录制现场突发状况，明星反应亮了',
    excerpt: '热门综艺最新一期录制现场突发意外状况，多位嘉宾明星的真实反应被现场观众拍到，慌乱、震惊、憋笑等表情包级瞬间引发网友二次创作热潮。',
    category: '51吃瓜视频',
    categorySlug: 'video',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20set%20with%20bright%20stage%20lights%20and%20cameras%2C%20dramatic%20warm%20amber%20lighting%2C%20abstract%20artistic%20style%2C%20editorial%20photography%20with%20dynamic%20composition%2C%20chaotic%20yet%20cinematic%20atmosphere%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=video-003&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 71200,
    date: '2026-07-04',
    author: '综艺前线',
    tags: ['综艺录制', '突发状况', '明星反应'],
    isExclusive: true,
  },
  {
    id: 'video-004',
    title: '偷拍视角：某艺人街头与粉丝冲突全过程，保安强行介入',
    excerpt: '路人拍摄的一段视频显示，某知名艺人在商场出席活动后遭粉丝围堵，过程中与一名近距离拍摄者发生口角，随行保安迅速介入将双方分开。',
    category: '51吃瓜视频',
    categorySlug: 'video',
    image: 'https://readdy.ai/api/search-image?query=Shopping%20mall%20atrium%20crowded%20with%20people%20and%20security%20personnel%2C%20dramatic%20warm%20lighting%20with%20tension%2C%20abstract%20artistic%20style%2C%20cinematic%20editorial%20photography%2C%20intense%20urban%20atmosphere%2C%20clean%20composition%2C%20no%20text%20or%20watermark&width=800&height=1067&seq=video-004&orientation=portrait',
    imageWidth: 800,
    imageHeight: 1067,
    hotScore: 65890,
    date: '2026-07-03',
    author: '街头目击',
    tags: ['粉丝冲突', '街头偷拍', '艺人出行'],
    isExclusive: false,
  },
];

export const allArticles: Article[] = [
  ...trendingArticles,
  ...competitionArticles,
  ...socialArticles,
  ...videoArticles,
];